
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1631505779450",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "6641",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M789.333333 170.666667a64 64 0 0 1 64 64v554.666666a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V234.666667a64 64 0 0 1 64-64h554.666666z m0 64H234.666667v554.666666h554.666666V234.666667z m-42.666666 384v64H277.333333v-64h469.333334zM469.333333 320a64 64 0 0 1 64 64v106.666667a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-106.666667a64 64 0 0 1 64-64h128z m277.333334 170.666667v64h-170.666667v-64h170.666667z m-277.333334-106.666667h-128v106.666667h128v-106.666667z",
        "p-id": "6642",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  